/* ============================================================
   sellerQuoteView (054819ad) — pure view logic for the public
   seller page's directed-quote card (upload a model, get a price
   from THIS seller's rates via POST /quotes { providerId }).
   ============================================================ */

export interface SellerQuoteFormState {
  modelFileId: string | null;
  materialId: string | null;
  copies: number;
  busy: boolean;
}

export interface SellerQuoteFormView {
  canQuote: boolean;
  buttonLabel: string;
  copies: number;
  /** Hint shown under the form while a model is still missing. */
  hint: string | null;
}

/** Copies stay in the 1–99 window (backend CheckLimits rejects beyond). */
export function clampCopies(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.min(99, Math.max(1, Math.round(value)));
}

export function buildSellerQuoteFormView(state: SellerQuoteFormState): SellerQuoteFormView {
  const copies = clampCopies(state.copies);
  if (state.busy) {
    return { canQuote: false, buttonLabel: 'Расчёт…', copies, hint: null };
  }
  if (!state.modelFileId) {
    return { canQuote: false, buttonLabel: 'Рассчитать у продавца', copies, hint: 'Сначала загрузите модель' };
  }
  if (!state.materialId) {
    return { canQuote: false, buttonLabel: 'Рассчитать у продавца', copies, hint: 'Выберите материал' };
  }
  return { canQuote: true, buttonLabel: 'Рассчитать у продавца', copies, hint: null };
}

/** Rating caption for the seller-page product card / header reuse. */
export function productRatingCaption(averageRating: number | null, reviewCount: number): string {
  if (averageRating === null || averageRating === undefined) return 'Нет отзывов';
  const avg = Number(averageRating);
  if (!Number.isFinite(avg)) return 'Нет отзывов';
  return `★ ${avg.toFixed(1)} · ${Math.max(0, Math.round(reviewCount))} отзыв(ов)`;
}
